import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { initCookieConsent } from "./lib/cookieConsent";
import { initSentry } from "./lib/sentry";

// Initialize error monitoring
initSentry();

// Initialize cookie consent
initCookieConsent();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
